import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { InputConvention } from "../../../InputConvention";
import { createConvention } from "../../../../../../../../store/conventionsSlice";
import { FORM_KEYS } from "../../../../../../constants";
import { getConventionsSelector } from "../../../../../../../../store/conventionsSlice";
import { useConventionIdForm } from "../../hooks/useConventionIdForm";
import FormContext from "../../../../../../../../context/formContext";
import { Modal } from "../../../../../../../../components";
import { MODAL_ID } from "../../../../../../../../utils/constants";

/**
 * @desc New Convention Modal.
 */
export const NewConventionModal = () => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();
  const { setValue } = useContext(FormContext);
  const conventions = useSelector(getConventionsSelector);
  const cnames = conventions.map((convention) => convention.name);
  const {
    resetField,
    control,
    handleSubmit,
    formState: { isValid },
  } = useConventionIdForm(cnames);
  const context = {
    control,
  };

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Creates a convention.
   */
  const handleCreateConvention = async (data) => {
    const response = await dispatch(createConvention(data[FORM_KEYS.CID]));
    const cname = response?.payload?.name;
    if (createConvention.fulfilled.match(response) && cname) {
      resetField(FORM_KEYS.CID);
      setValue(FORM_KEYS.CNAME, cname);
      toast.success(`Success`);
    } else {
      toast.error(`Failed to create new convention: ${cname}`);
    }
  };

  // HOOK ---------------------------------------------------------------------

  const modalProps = {
    id: MODAL_ID.CREATE_NEW_CONVENTION,
    disabled: !isValid,
    header: "Create a New Convention",
    children: (
      <FormContext.Provider value={context}>
        <InputConvention />
      </FormContext.Provider>
    ),
    ctaText: "CREATE",
    showCancelButton: true,
    onClick: handleSubmit(handleCreateConvention),
  };

  return <Modal {...modalProps} />;
};

export default NewConventionModal;
